import { InputItem, List, WhiteSpace, Button, Toast } from "antd-mobile-v2";
import React, { Component } from "react";
import { createForm } from "rc-form";
import "./index.less";
import { get, headerGet, post } from "../../../api/service/services";
import allUrl from "../../../api/allUrl";
import tool from "../../../api/tool";
import sectioValue from "../../../api/service/secsstion";
import { userInfoData } from "../../../public/getUserInfo";
const tabs = [{ title: "账号登录" }, { title: "短信登录" }];
const Item = List.Item;
class VerctionPhone extends React.Component {
  constructor() {
    super();
    this.state = {
      count: 60,
      flagCode: true,
      imageKey: {},
      userData: {},
      type: "forget",
    };
  }
  // 获取验证码
  isPhone = () => {
    const { flagCode } = this.state;
    let imageCode = this.props.form.getFieldValue("imageCode");
    let phoneS = this.props.form.getFieldValue("phoneNumber");
    if (!imageCode) {
      Toast.fail("请输入图片验证码", 1);
      return;
    }
    if (!phoneS) {
      Toast.fail("请输入手机号", 1);
      return;
    }
    if (!flagCode) return;
    // 验证图片验证码
    headerGet(
      allUrl.register.captchaImage,
      {},
      { "Captcha-Code": imageCode, "Captcha-Key": this.state.imageKey.imageKey }
    ).then((res) => {
      if (res.success === true && res.code == 200) {
        this.getPhoneCode(phoneS);
      } else {
        Toast.fail(res.msg, 1,()=>{
          this.getImageCode();
        });
     
      }
    });
  };
  // 获取手机验证码
  getPhoneCode = (phoneS) => {
    get(allUrl.register.getIsPhoneCode, { phone: phoneS })
      .then((res) => {
        if (res.success === true && res.code == 200) {
          this.countDown();
        } else {
          Toast.fail(res.msg, 1);
        }
      })
      .catch((error) => {
        Toast.fail("验证码获取失败", 1);
      });
  };
  componentDidMount() {
    this.getImageCode();
    this.getuserInfoData();
  }
  // 获取用户信息
  getuserInfoData = async () => {
    let userData;
    let userCode = sectioValue.get("acount");
    if (!userCode) {
      this.setState({ type: "forget" });
      return;
    }
    userData = tool.get("userInfoData");
    if (!userData) {
      userData = await userInfoData();
    }
    this.setState({ userData: userData, type: "edit" });
  };
  // 获取图片验证码
  getImageCode = () => {
    get(allUrl.register.getImageCode, {})
      .then((res) => {
        if (res.success === true && res.code == 200) {
          let imgKey = res.data.key || "";
          let imageUrl = res.data.image || "";
          this.setState({
            imageKey: {
              imageKey: imgKey,
              imageUrl: imageUrl,
            },
          });
        } else {
          Toast.info(res.data.msg, 1);
        }
      })
      .catch((err) => {
        Toast.info("验证码获取失败，请重试", 1);
      });
  };
  // 倒计时
  countDown = () => {
    const { count, flagCode } = this.state;
    let timer = null;
    let num = count;
    this.setState({
      flagCode: false,
    });
    timer = setInterval(() => {
      if (num <= 1) {
        clearInterval(timer);
        num = 60;
        this.setState({
          flagCode: true,
        });
      }
      num--;
      this.setState({
        count: num,
      });
    }, 1000);
  };
  validateAccount = (rule, value, callback) => {
    if (value && value.length > 4) {
      callback();
    } else {
      callback(new Error("At least four characters for account"));
    }
  };
  // 数据提交
  onSubmit = () => {
    const { submitData } = this.props;
    this.props.form.validateFields({ force: true }, (error, values) => {
      if (error) {
        let errorData = Object.keys(error)[0];
        Toast.info(error[errorData].errors[0].message, 1);
        return;
      }
      if (this.state.type == "edit") {
        values["userCode"] = sectioValue.get("acount") || "";
      }
      this.requestSubmit(values);
    });
  };
  // 下一步接口请求
  requestSubmit = (data) => {
    const { submitData } = this.props;
    let newData = { ...data, verifyType: 2 };
    post(
      allUrl.register.passWordForget,
      {
        ...newData,
      },
      {
        "Content-Type": "application/json;charset=UTF-8",
        "Captcha-SMS-Code": data.phoneCode,
      }
    )
      .then((res) => {
        if (res.code === 200 && res.success === true) {
          tool.set("validation", {
            type: "phonetiality", // 手机验证
            data: newData,
          });
          submitData();
        } else {
          Toast.info(res.msg, 1);
        }
      })
      .catch((err) => {
        Toast.info(
          err && err.data && err.data.msg ? err.data.msg : "提交失败",
          1
        );
      });
  };
  render() {
    const { getFieldProps, getFieldError } = this.props.form;
    const { flagCode, count, userData, type } = this.state;
    return (
      <div className="wrap-verificationPhone">
        <form>
          <List>
            <InputItem
              {...getFieldProps("phoneNumber", {
                initialValue:
                  userData && userData.phoneNumber ? userData.phoneNumber : "",
                rules: [{ required: true, message: "请输入手机号码" }],
              })}
              clear
              error={!!getFieldError("phoneNumber")}
              onErrorClick={() => {
                alert(getFieldError("phoneNumber").join("、"));
              }}
              disabled={type == "edit" ? true : false}
              placeholder="请输入手机号码"
              labelNumber={8}
            >
              <span style={{ color: "red" }}>*</span> 手机号码
            </InputItem>
            <div className="item-cont">
              <InputItem
                {...getFieldProps("imageCode", {
                  rules: [{ required: true, message: "请输入图片验证码" }],
                })}
                placeholder="请输入图片验证码"
                type=""
                labelNumber={8}
              >
                <span style={{ color: "red" }}>*</span> 图片验证码
              </InputItem>
              <div
                className="code-image"
                onClick={() => {
                  this.getImageCode();
                }}
              >
                <img src={this.state.imageKey.imageUrl || ""}></img>
              </div>
            </div>
            <div className="item-cont">
              <InputItem
                {...getFieldProps("phoneCode", {
                  // initialValue: 'little ant',
                  rules: [{ required: true, message: "请输入验证码" }],
                })}
                clear
                error={!!getFieldError("phoneCode")}
                onErrorClick={() => {
                  alert(getFieldError("phoneCode").join("、"));
                }}
                placeholder="请输入验证码"
                labelNumber={8}
              >
                <span style={{ color: "red" }}>*</span> 验证信息
              </InputItem>
              <div
                className="code-phone"
                onClick={() => {
                  this.isPhone();
                }}
                style={{
                  color: flagCode ? "#337fd3" : "#ccc",
                  borderColor: flagCode ? "#337fd3" : "#ccc",
                }}
              >
                {flagCode ? "获取验证码" : `${count}S重新获取`}
              </div>
            </div>
            <WhiteSpace />
            <WhiteSpace />
            <WhiteSpace />
            <Item>
              <Button type="primary" onClick={this.onSubmit}>
                下一步
              </Button>
            </Item>
          </List>
        </form>
      </div>
    );
  }
}

export default createForm()(VerctionPhone);
